import { createFileRoute } from "@tanstack/react-router";
import { AnalyticsOverview } from "@/features/analytics/overview/analytics-overview";

export const Route = createFileRoute("/analytics/")({
  component: AnalyticsOverview,
});
